
    <template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 14">
  <path
    d="M14.432 5.15208H0.718045C0.32148 5.15208 0 4.8306 0 4.43403C0 4.03747 0.32148 3.71599 0.718045 3.71599H12.2099L8.77695 1.30679C8.5662 1.15973 8.45013 0.911254 8.47258 0.655257C8.49503 0.399259 8.65259 0.174782 8.88572 0.0666539C9.11884 -0.0414742 9.39198 -0.0167633 9.60191 0.131449L14.7249 3.72664C14.7826 3.76724 14.834 3.8161 14.8775 3.87167C15.0497 4.00755 15.1501 4.21479 15.15 4.43409C15.15 4.83062 14.8286 5.15208 14.432 5.15208ZM0.718045 8.01863H14.432C14.8286 8.01863 15.15 8.34009 15.15 8.73662C15.15 9.13315 14.8286 9.4546 14.432 9.4546H2.94021L6.37313 11.8638C6.69769 12.0916 6.77613 12.5394 6.54832 12.864C6.43904 13.02 6.27221 13.1261 6.0846 13.159C5.89698 13.1919 5.70399 13.1488 5.54817 13.0393L0.425227 9.44395C0.365873 9.40231 0.315016 9.35313 0.272535 9.29892C0.100353 9.16313 -6.66514e-05 8.9559 5.98237e-05 8.73662C5.98237e-05 8.5462 0.0757044 8.36357 0.210353 8.22892C0.345001 8.09428 0.527623 8.01863 0.718045 8.01863Z"
    fill="currentColor"
  ></path>
</svg>

    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'Switch',
    }) as DefineComponent
    </script>
    